// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";
import "./ShadersInclude/kernelBlurVaryingDeclaration";
import "./ShadersInclude/packingFunctions";
import "./ShadersInclude/kernelBlurFragment";
import "./ShadersInclude/kernelBlurFragment2";

const name = "kernelBlurPixelShader";
const shader = `uniform sampler2D textureSampler;uniform vec2 delta;varying vec2 sampleCenter;#ifdef DOF
uniform sampler2D circleOfConfusionSampler;uniform vec2 cameraMinMaxZ;float sampleDistance(in vec2 offset) {float depth=texture2D(circleOfConfusionSampler,offset).g; return cameraMinMaxZ.x+(cameraMinMaxZ.y-cameraMinMaxZ.x)*depth; }float sampleCoC(in vec2 offset) {float coc=texture2D(circleOfConfusionSampler,offset).r; return coc; }#endif
#include<kernelBlurVaryingDeclaration>[0..varyingCount]
#ifdef PACKEDFLOAT
#include<packingFunctions>
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void){float computedWeight=0.0;#ifdef PACKEDFLOAT 
float blend=0.;#else
vec4 blend=vec4(0.);#endif
#ifdef DOF
float sumOfWeights=CENTER_WEIGHT; float factor=0.0;#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter))*CENTER_WEIGHT;#else
blend+=texture2D(textureSampler,sampleCenter)*CENTER_WEIGHT;#endif
#endif
#include<kernelBlurFragment>[0..varyingCount]
#include<kernelBlurFragment2>[0..depCount]
#ifdef PACKEDFLOAT
gl_FragColor=pack(blend);#else
gl_FragColor=blend;#endif
#ifdef DOF
gl_FragColor/=sumOfWeights;#endif
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
/** @internal */
export const kernelBlurPixelShader = { name, shader };
